import AuthService from "@/services/auth";
//import {router} from '@/plugins/router'

let user = {};
let local = {
  localstorage: true,
  sendMail: false,
  sendRequestResetMail: false
};
try {
  user = JSON.parse(localStorage.getItem("user"));
} catch (err) {
  local.localStorage = false;
  console.warn("No access to local storage");
}
const initialUser = user && user.name
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: { token: "" } };

export default {
  namespaced: false,
  state: {
    ...initialUser,
    ...local,
  },
  actions: {
    login({ dispatch, commit }, param) {
      commit("loginRequest", { email: param.email });
      AuthService.postSignin(param)
        .then((user) => {
          commit("loginSuccess", user.data);
          try {
            localStorage.setItem("user", JSON.stringify(user.data));
          } catch (err) {
            console.warn("No access to local storage");
          }
        })
        .catch((err) => {
          commit("loginFailure");
          /*if (err.indexOf("Error: Request failed with status code 401") !== -1) {
                        dispatch("alert/error", "Votre identifiant ou mot de passe est invalide.", { root: true });
                    }*/
          dispatch(
            "alert/error",
            "Votre identifiant ou mot de passe est invalide.",
            { root: true }
          );
        });
    },
    logout({ commit, state }) {
      if (state.status.loggedIn === true) {
        try {
          AuthService.postLogout().then(() => {
            try {
              localStorage.removeItem("user");
            } catch (err) {
              console.log("No access to local storage");
            }
            commit("logout");
          });
        } catch (err) {
          try {
            localStorage.removeItem("user");
          } catch (err) {
            console.log("No access to local storage");
          }
          commit("logout");
        }
      } else {
        try {
          localStorage.removeItem("user");
        } catch (err) {
          console.log("No access to local storage");
        }
        commit("logout");
      }
    },
    requestReset({ dispatch, commit }, param) {
      AuthService.postRequestReset(param)
        .then((user) => {
          commit("requestResetSuccess");
          dispatch("alert/success", "Le courriel a été envoyé !", {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err)
          dispatch("alert/error", "Échec de l'envoie du courriel, car l'utilisateur n'existe pas.", {
            root: true,
          });
        });
    },
    resetPassword({ dispatch }, payload) {
      AuthService.postReset(payload)
        .then((user) => {
          dispatch("login", {
            email: user.data.email,
            password: payload.password,
          });
          dispatch("alert/success", "Le mot de passe a été sauvegarder !", {
            root: true,
          });
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    updatePassword({ dispatch }, payload) {
      AuthService.putPassword(payload)
        .then((result) => {
          dispatch("alert/success", "Le mot de passe a été sauvegarder !", {
            root: true,
          });
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    refreshToken({ commit, dispatch }, param) {
      return new Promise(
        (resolve, reject) => {
          AuthService.postRefresh(param)
            .then(function (response) {
              let user = null;
              try {
                user = JSON.parse(localStorage.getItem("user"));
                
              } catch (err) {
                console.warn("No access to local storage");
              }
              if (!user || user === null || !user.name) {
                commit("expire");
                dispatch("logout");
                reject(error);
              }
              else{
                user.token = response.data.access_token;
                user.refresh_token = response.data.refresh_token;
                try {
                  localStorage.setItem("user", JSON.stringify(user));
                } catch (err) {
                  console.warn("No access to local storage");
                }

                commit("loginSuccess", user);
                resolve(response);
              }
            })
            .catch(function (error) {
              commit("expire");
              dispatch("logout");
              reject(error);
            });
        },
        (error) => console.log(error)
      );
    },
    register({ dispatch, commit }, payload) {
      AuthService.postRegister(payload)
        .then((result) => {
          commit("registerSuccess");
          dispatch("alert/success", "Le courriel a été envoyé !", {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          dispatch("alert/error", "Cette adresse courriel est déjà utilisée.", { root: true });
        });
    },
    validation({ dispatch, commit }, payload) {
      AuthService.postValidation(payload)
        .then((user) => {
          commit("loginSuccess", user.data);
          try {
            localStorage.setItem("user", JSON.stringify(user.data));
          } catch (err) {
            console.warn("No access to local storage");
          }
          //dispatch("alert/success", "Validation succeed", { root: true });
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    resentEmail({ dispatch }, payload) {
      AuthService.postResent(payload)
        .then((result) => {
          dispatch("alert/success", "Le courriel a été envoyé !", {
            root: true,
          });
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: false };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = { token: "" };
    },
    logout(state) {
      state.status = {};
      state.user = { token: "" };
      window.location.href = "https://www.voyages-lambert.com/?disconnect_user=1";
    },
    expire(state) {
      state.status = {};
    },
    registerSuccess(state) {
      state.sendMail = true;
    },
    requestResetSuccess(state){
      state.sendRequestResetMail = true;
    }
  },
};
